import ActionTypes from '../constants/ActionTypes';
import api from '../constants/api';
import { authHeader } from '../helpers';
import { postApi } from '../helpers/http';

export const requestOsSettings = date => ({
  type: ActionTypes.REQUEST_OS_SETTING,
  date
})

export const receiveOsSettings = (params, json) => ({
  type: ActionTypes.RECEIVE_OS_SETTING,
  date: params.date,
  items: json.data,
  receivedAt: Date.now()
})

const doFetchOsSettings = params => async dispatch => {
  dispatch(requestOsSettings(params))

  const data = {
        "process_type": "getMasterList", 
        "table_name": "os_master",
        // "offset": params.offset,
        // "limit": params.limit
  };

  try {
    const json = await postApi(data);
    dispatch(receiveOsSettings(params, json));
  } catch (error) {
    console.error('Error:', error);
  };

  // return fetch(api.url, {
  //   method: 'POST',
  //   headers: authHeader(),
  //   body: JSON.stringify(data),
  // })
  // .then(response => response.json())
  // .then(json => {
  //   // console.log('Success:', json.data);
  //   dispatch(receiveOsSettings(params, json))
  // })
  // .catch((error) => {
  //   console.error('Error:', error);
  // });
}

export const fetchOsSettings = params => (dispatch, getState) => {
  return dispatch(doFetchOsSettings(params))
}

